import { render, staticRenderFns } from "./listDialog.vue?vue&type=template&id=b813aec4"
import script from "./listDialog.vue?vue&type=script&lang=js"
export * from "./listDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports